module.exports = __webpack_public_path__ + "img/contentImg6.5f98b86.webp";